module.exports = __webpack_public_path__ + "img/login-img.b36b6ce4.jpg";